import { get } from 'lodash';
import { instance } from './api.service';

export const getOrder = async (id) => {
  const resp = await instance.get(`/orders/${id}`, { data: {} });
  return get(resp, 'data.order', null);
};

export const getOrders = async (where, opts = {}) => {
  let resp = {};
  if (where) {
    resp = await instance.post(`/orders`, {
      where,
    });
  } else {
    resp = await instance.get(`/orders?${new URLSearchParams(opts).toString()}`, { data: {} });
  }
  return get(resp, 'data.orders', []);
};

export const getUserOrders = async (where, opts = {}) => {
  let resp = {};
  if (where) {
    resp = await instance.post(`/orders/userorders`, {
      where,
    });
  } else {
    resp = await instance.get(`/orders?${new URLSearchParams(opts).toString()}`, { data: {} });
  }
  return get(resp, 'data.orders', []);
};

export const getSchedule = async (opts = {}) => {
  const resp = await instance({
    url: `/orders/schedule`,
    method: 'post',
    credentials: 'include',
    data: {
      opts
    }
  });
  return get(resp, 'data.schedule', []);
};

export const getReconciliation = async (opts = {}) => {
  const resp = await instance({
    url: `/orders/reconciliation`,
    method: 'post',
    credentials: 'include',
    data: {
      opts
    }
  });
  return get(resp, 'data.data', []);
};

export const getReconList = async (opts = {}) => {
  const resp = await instance({
    url: `/orders/reconlist`,
    method: 'post',
    credentials: 'include',
    data: {
      opts
    }
  });
  return get(resp, 'data.data', []);
};

export const createReconciliation = async (data = {}) => {
  const resp = await instance({
    url: `/orders/createreconciliation`,
    method: 'post',
    credentials: 'include',
    data
  });
  return get(resp, 'data.data', []);
};

// Card #283 — resolve what a Recon Form QR code points at: the identifiers of
// the reconciliation's Reconciliation Return order (round 3 — the scan opens
// that order, not the PDF), plus the recon's document for reference. The
// endpoint rejects the anonymous `temp@temp.com` identity and scopes the recon
// to the caller's licence family, so this only succeeds for a signed-in user
// entitled to that reconciliation. `config` carries the caller's cancelToken:
// the recon page cancels this on unmount so a late resolve cannot open the
// order after the app has already redirected to login.
export const getReconDocument = async (reconId, config = {}) => {
  const resp = await instance.get(`/orders/recon/${reconId}`, { data: {}, ...config });
  return get(resp, 'data.data', null);
};

export const deleteReconciliation = async (reconIds = []) => {
  const resp = await instance({
    url: `/orders/deletereconciliation`,
    method: 'post',
    credentials: 'include',
    data: { reconIds }
  });
  return get(resp, 'data', {});
};

export const getOrdersRange = async (opts = {}) => {
  const resp = await instance({
    url: `/orders/ordersrange`,
    method: 'post',
    credentials: 'include',
    data: {
      opts
    }
  });
  return get(resp, 'data.data', []);
};

export const getOrdersRangeForUser = async (opts = {}) => {
  const resp = await instance({
    url: `/orders/ordersrangeforuser`,
    method: 'post',
    credentials: 'include',
    data: {
      opts
    }
  });
  return get(resp, 'data.data', []);
};

export const createOrder = async (order) => {
  const resp = await instance.post('/orders/create', {
    order: order,
  });
  return get(resp, 'data.order', null);
};

export const updateOrder = async (order) => {
  const resp = await instance.post('/orders/update', {
    order: order,
  });
  return get(resp, 'data.order', null);
};

export const deleteOrder = async (order) => {
  const resp = await instance.post('/orders/delete', {
    order: order,
  });
  return get(resp, 'data.order', null);
};

export const undeleteOrder = async (order) => {
  const resp = await instance.post('/orders/undelete', {
    order: order,
  });
  return get(resp, 'data.order', null);
};

export const cancelOrder = async (order) => {
  const resp = await instance.post('/orders/cancel', {
    order,
  });
  return get(resp, 'data.order', null);
};

export const syncManifests = async (opts = {}) => {
  const resp = await instance.post('/metrc/syncall', {
    body: {
      ...opts,
    },
  });
  return get(resp, 'data.data', null);
}

export const fixOrdersAndNotify = async (data = {}) => {
  const resp = await instance({
    url: `/orders/fixorders`,
    method: 'post',
    credentials: 'include',
    data,
  });
  return get(resp, 'data.ordersToUpdate', []);
};

export const sendManifest = async (data) => {
  const resp = await instance({
    url: `/orders/manifestupload`,
    method: 'post',
    data
  })
  return get(resp, 'data', {});
}

export const signManifest = async (data) => {
  const resp = await instance({
    url: `/orders/signmanifest`,
    method: 'post',
    data
  })
  return get(resp, 'data', {});
}

export const signRecon = async (data) => {
  const resp = await instance({
    url: `/orders/signrecon`,
    method: 'post',
    data
  })
  return get(resp, 'data', {});
}

export const mergePdfs = async (data) => {
  const resp = await instance({
    url: `/orders/mergePdfs`,
    method: 'post',
    data
  })
  return get(resp, 'data', {});
}

export const runSignatureReport = async (data) => {
  const resp = await instance({
    url: `/orders/signaturereport`,
    method: 'post',
    data
  })
  return get(resp, 'data.data', {});
}